import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

const savedDarkMode = localStorage.getItem('darkMode');
if (savedDarkMode) {
  try {
    const isDarkMode = JSON.parse(savedDarkMode);
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  } catch {
    document.body.classList.remove('dark-mode');
  }
} else {
  document.body.classList.remove('dark-mode');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
